import { createSvgIcon } from "@mui/material/utils";

/**
 * Building icon.
 *
 * ![BuildingIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMS45MiAtMS45MiAxOS44NCAxOS44NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHN0eWxlPSJiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czo0cHgiPjxwYXRoIGQ9Ik00Ljk5ODcgNC42NjY2N0g2LjgzMjAzTTQuOTk4NyA3LjMzMzMzSDYuODMyMDNNNC45OTg3IDEwSDYuODMyMDNNOS4xNjUzNiA0LjY2NjY3SDEwLjk5ODdNOS4xNjUzNiA3LjMzMzMzSDEwLjk5ODdNOS4xNjUzNiAxMEgxMC45OTg3TTEzLjMzMiAxNFY0LjEzMzMzQzEzLjMzMiAzLjM4NjYgMTMuMzMyIDMuMDEzMjMgMTMuMTg2NyAyLjcyODAxQzEzLjA1ODkgMi40NzcxMyAxMi44NTQ5IDIuMjczMTYgMTIuNjA0IDIuMTQ1MzJDMTIuMzE4OCAyIDExLjk0NTQgMiAxMS4xOTg3IDJINC43OTg3QzQuMDUxOTYgMiAzLjY3ODU5IDIgMy4zOTMzOCAyLjE0NTMyQzMuMTQyNDkgMi4yNzMxNiAyLjkzODUyIDIuNDc3MTMgMi44MTA2OSAyLjcyODAxQzIuNjY1MzYgMy4wMTMyMyAyLjY2NTM2IDMuMzg2NiAyLjY2NTM2IDQuMTMzMzNWMTRNMTQuNjY1NCAxNEgxLjMzMjAzIiBzdHJva2U9IiMxMDE4MjgiIHN0cm9rZS13aWR0aD0iMS4zMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+PC9zdmc+)
 */
const BuildingIcon = createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.9987 4.66667H6.83203M4.9987 7.33333H6.83203M4.9987 10H6.83203M9.16536 4.66667H10.9987M9.16536 7.33333H10.9987M9.16536 10H10.9987M13.332 14V4.13333C13.332 3.3866 13.332 3.01323 13.1867 2.72801C13.0589 2.47713 12.8549 2.27316 12.604 2.14532C12.3188 2 11.9454 2 11.1987 2H4.7987C4.05196 2 3.67859 2 3.39338 2.14532C3.14249 2.27316 2.93852 2.47713 2.81069 2.72801C2.66536 3.01323 2.66536 3.3866 2.66536 4.13333V14M14.6654 14H1.33203"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Building"
);

export default BuildingIcon;
